import React from 'react';
function Heading6({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 4v16M3.5 12h8M12 4v16M17 18c-.285-1.725-.098-3.285.498-4.217.597-.931 2.218-1.112 3.217 0"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 20a2 2 0 100-4 2 2 0 000 4z" />
    </svg>
  );
}

export default Heading6;
